
<template>
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_226_458)">
      <path
        d="M13.4163 2.83342V6.33342M13.4163 6.33342H9.91634M13.4163 6.33342L10.7097 3.79008C10.0827
         3.16283 9.30712 2.70462 8.4552 2.4582C7.60328 2.21178 6.70282 2.18519 5.83784 2.3809C4.97286
          2.57661 4.17156 2.98825 3.5087 3.57741C2.84584 4.16657 2.34302 4.91404 2.04717
           5.75008M0.583008 12.1668V8.66675M0.583008 8.66675H4.08301M0.583008 8.66675L3.28967
            11.2101C3.91661 11.8373 4.69223 12.2955 5.54415 12.542C6.39607 12.7884 7.29653
             12.815 8.16151 12.6193C9.02649 12.4236 9.82779 12.0119 10.4907 11.4228C11.1535
              10.8336 11.6563 10.0861 11.9522 9.25008"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_226_458">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>